import { MainTitle, TextList } from '@repo/ui';

export const GuidelinesAndPrecautions = () => {
  const SHORT_GUIDELINE_DATA = [
    '체납중이거나, 납기중인 세금이 있는 경우 환급금이 국세청에서 자동으로 충당돼요.',
    '환급이 완료되면, 국세청에서 결정한 환급액의 30%(부가세별도)를 이용료로 요청해요.'
  ];

  return (
    <section className={'py-normal-medium'}>
      <div className={'max-w-[520px] mx-auto page-padding'}>
        <MainTitle className={'pt-normal-large pb-normal-medium'} title={'안내 및 주의사항'} size={'small'} />
        {SHORT_GUIDELINE_DATA.map((text, idx) => (
          <TextList className={'text-neutral-foreground-low py-0.5'} key={idx} variant={'bullet'} size={'medium'}>
            {text}
          </TextList>
        ))}
      </div>
    </section>
  );
};
